var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Drawer, DrawerBody, DrawerFooter, DrawerHeader, Link, } from '@one-thd/sui-atomic-components';
import { Printer } from '@one-thd/sui-icons';
import React, { useRef, useState } from 'react';
import { GetOrderDetailsPDF } from '../../hooks/order-details-hooks/order-details-page-header-hooks';
import { pushEventInfo } from '../../utils/analytics';
import { getSvocId } from '../../utils/user';
import { orderNumberFormat } from './order-number-formatter/OrderNumberFormatter';
import { useCommonContext } from '../../hooks/useContexts';
export var PrintButton = function (_a) {
    var _b = _a.layout, layout = _b === void 0 ? 'detail' : _b, orderDetailsData = _a.orderDetailsData, setAlertState = _a.setAlertState;
    var _c = useState(false), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(null), pdfData = _e[0], setPdfData = _e[1];
    var iframeRef = useRef(null);
    var timezone = useCommonContext().timezone;
    var handleOpen = function () { return setOpen(true); };
    var handleClose = function () { return setOpen(false); };
    var printClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(layout === 'detail')) return [3 /*break*/, 2];
                    pushEventInfo({
                        category: { primaryCategory: 'button submission' },
                        eventInfo: { eventName: 'my account settings' },
                        myAccount: { settings: 'purchase details: print' },
                    });
                    handleOpen();
                    setLoading(true);
                    return [4 /*yield*/, printReceipt()];
                case 1:
                    data = _a.sent();
                    if (data instanceof Blob) {
                        url = URL.createObjectURL(data);
                        setPdfData(url);
                    }
                    else {
                        setPdfData(null);
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2:
                    if (layout === 'table') {
                        printReceipt();
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var printReceipt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isOnlineFlag, printRequest, res;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isOnlineFlag = (orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderOrigin) === 'Online';
                    if (isOnlineFlag) {
                        printRequest = {
                            orderDetailsRequest: {
                                searchType: 'online',
                                customerAccountId: getSvocId() || '',
                                orderNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
                                exportType: 'pdf',
                                timezone: timezone,
                            },
                        };
                    }
                    else if (((_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber) === null || _a === void 0 ? void 0 : _a[0]) === 'H') {
                        printRequest = {
                            orderDetailsRequest: {
                                customerAccountId: getSvocId() || '',
                                exportType: 'pdf',
                                orderNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber,
                                registerNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber,
                                salesDate: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate,
                                searchType: 'instore',
                                storeNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber,
                                transactionId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId,
                                timezone: timezone,
                            },
                        };
                    }
                    else {
                        printRequest = {
                            orderDetailsRequest: {
                                customerAccountId: getSvocId() || '',
                                exportType: 'pdf',
                                registerNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber,
                                salesDate: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.salesDate,
                                searchType: 'instore',
                                storeNumber: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.storeNumber,
                                transactionId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId,
                                timezone: timezone,
                            },
                        };
                    }
                    return [4 /*yield*/, GetOrderDetailsPDF(printRequest, isOnlineFlag ? 'online' : 'instore', setLoading, setAlertState, layout)];
                case 1:
                    res = _b.sent();
                    return [2 /*return*/, res];
            }
        });
    }); };
    if (layout === 'table') {
        return (React.createElement(Link, { variant: "body-sm", underline: "none", onClick: printClick }, "Print"));
    }
    var receiptNumber = orderNumberFormat(orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.orderNumber, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.transactionId, orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.registerNumber);
    var handlePrintIframe = function () {
        var iframe = iframeRef.current;
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }
    };
    return (React.createElement("div", { className: "sui-flex sui-pl-4" },
        React.createElement(Button, { onClick: printClick, variant: "ghost", startIcon: Printer }, "Print"),
        React.createElement(Drawer, { open: open, onClose: handleClose, position: "right" },
            React.createElement(DrawerHeader, { title: receiptNumber, onClose: handleClose }),
            React.createElement(DrawerBody, null, pdfData && (React.createElement("iframe", { ref: iframeRef, src: pdfData, title: "PDF Preview", width: "100%", height: "100%", style: { border: 'none' } }))),
            React.createElement(DrawerFooter, { className: "card-fix sui-p-[16px]" },
                React.createElement("div", { className: "sui-flex sui-flex-col sui-w-full sui-gap-[16px]" },
                    React.createElement(Button, { variant: "primary", onClick: handlePrintIframe, disabled: loading }, "Print"))))));
};
